import { useMantineTheme } from "@mantine/core";
import useMediaQuery from "./useMediaQuery";

function useIsMobile() {
  const theme = useMantineTheme();
  return useMediaQuery(`(max-width: calc(${theme.breakpoints.md} - 1px)`);
}

export default useIsMobile;
